// extracted by mini-css-extract-plugin
export default {"widgetViewButtons":"WidgetViewButtons_widgetViewButtons__zRfG0"};